<template>
  <iframe
    :src="
      `${this.quoteUrlNew}/app/faq?token=${api_token}&lang=${$i18n.locale}-${
        $i18n.locale === 'fr'
          ? $i18n.locale.toUpperCase()
          : $i18n.locale === 'en'
          ? 'GB'
          : 'SE'
      }`
    "
    width="100%"
    height="100%"
    style="height:100vh;"
    frameBorder="0"
  />
</template>
<script>
export default {
  metaInfo() {
    return {
      title: 'FAQ',
    };
  },
  data() {
    return {
      quoteUrlNew: process.env.VUE_APP_QUOTES_URL_NEW,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    api_token() {
      return sessionStorage.getItem('api_token');
    },
  },
};
</script>
<style>
